<div class="container-wrapper">
    <form [formGroup]="createpTicketForm">


        <h2 matDialogTitle>
            Create new ticket
        </h2>
        <mat-dialog-content>



            <mat-stepper [linear]="isLinear" #stepper orientation="horizontal">
                <mat-step [stepControl]="createpTicketForm" label="General Information">
                    <div class="mat-step-spacer">
                        <div class="multi-input-group">
                            <mat-form-field class="input-group">
                                <mat-label>Support level</mat-label>
                                <mat-select formControlName="pct_supportlevel" [disabled]="isCreatingTicket">
                                    <mat-option *ngFor="let supportlevel of supportlevels"
                                        [value]="supportlevel.msl_value">
                                        {{ supportlevel.msl_value }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="input-group">
                                <mat-label>Status</mat-label>
                                <mat-select formControlName="pct_status" [disabled]="isCreatingTicket">
                                    <mat-option *ngFor="let status of statuus" [value]="status">
                                        {{ status }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="input-group">
                                <mat-label>Ticket type</mat-label>
                                <mat-select formControlName="pct_tickettype" [disabled]="isCreatingTicket">
                                    <mat-option *ngFor="let type of ticketTypes" [value]="type.mtt_value">
                                        {{ type.mtt_value }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-step>
                <mat-step [stepControl]="createpTicketForm" label="User Information">
                    <div class="mat-step-spacer">

                        <div class="multi-input-group">
                            <mat-form-field class="input-group">
                                <mat-label>User name</mat-label>
                                <input matInput [matAutocomplete]="auto" formControlName="pct_user"
                                    [disabled]="isCreatingTicket">
                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onNameSelected($event)">
                                    <mat-option *ngIf="isLoadingRecommendations" disabled>...Loading</mat-option>
                                    <div *ngIf="!isLoadingRecommendations">
                                        <mat-option *ngFor="let entry of pTicketRecommendations" [value]="entry">
                                            <div class="option-primary">{{ entry.pct_user }}</div>
                                            <div class="option-secondary">
                                                {{ entry.pct_company }} | {{ entry.pct_responsename }} | {{
                                                entry.pct_useremail }}
                                            </div>
                                        </mat-option>
                                    </div>
                                </mat-autocomplete>
                            </mat-form-field>
                            <mat-form-field class="input-group">
                                <mat-label>Response name</mat-label>
                                <input matInput formControlName="pct_responsename" [disabled]="isCreatingTicket">
                            </mat-form-field>
                        </div>
                        <mat-form-field class="input-group">
                            <mat-label>Company</mat-label>
                            <input matInput [matAutocomplete]="countryAuto" formControlName="pct_company"
                                [disabled]="isCreatingTicket">

                            <mat-autocomplete #countryAuto="matAutocomplete"
                                (optionSelected)="onCompanySelected($event)">
                                <mat-option *ngIf="isLoadingCompanyRecommendations" disabled>...Loading</mat-option>
                                <div *ngIf="!isLoadingCompanyRecommendations">
                                    <mat-option *ngFor="let entry of companyRecommendations" [value]="entry">
                                        <div class="option-primary">{{ entry.pct_company }}</div>
                                        <div class="option-secondary">
                                            {{ entry.pct_countrycode }}
                                        </div>
                                    </mat-option>
                                </div>
                            </mat-autocomplete>


                        </mat-form-field>
                        <div class="input-group">
                            <app-phone-number [formGroup]="createpTicketForm"></app-phone-number>
                        </div>
                        <div class="multi-input-group">
                            <mat-form-field class="input-group">
                                <mat-label>User mail</mat-label>
                                <input matInput formControlName="pct_useremail" [disabled]="isCreatingTicket">
                            </mat-form-field>
                            <mat-form-field class="input-group">
                                <mat-label>Response mail</mat-label>
                                <input matInput formControlName="pct_responseemail" [disabled]="isCreatingTicket">
                            </mat-form-field>
                        </div>
                    </div>
                </mat-step>
                <mat-step [stepControl]="createpTicketForm" label="Ticket Data">
                    <div class="mat-step-spacer">
                        <mat-form-field class="input-group">
                            <mat-label>Product</mat-label>
                            <mat-select formControlName="pct_product" [disabled]="isCreatingTicket">
                                <mat-option *ngFor="let product of pProducts" [value]="product.ppd_name">
                                    {{ product.ppd_name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="input-group">
                            <mat-label>Initial description</mat-label>
                            <textarea matInput formControlName="pct_initialdescription" [disabled]="isCreatingTicket"
                                style="min-height: 200px;"></textarea>
                        </mat-form-field>
                        <app-upload-files #fileUpload></app-upload-files>                 
                    </div>
                </mat-step>
            </mat-stepper>
        </mat-dialog-content>

        <mat-dialog-actions *ngIf="stepper.selectedIndex == 0">
            <button mat-flat-button (click)="onCancel()" [disabled]="isCreatingTicket">Cancel</button>
            <button mat-raised-button color="primary" (click)="stepper.next()" style="max-width: 200px;"
                [disabled]="isCreatingTicket">Next</button>
        </mat-dialog-actions>

        <mat-dialog-actions *ngIf="stepper.selectedIndex == 1">
            <button mat-flat-button (click)="stepper.previous()" [disabled]="isCreatingTicket">Back</button>
            <button mat-raised-button color="primary" (click)="stepper.next()" style="max-width: 200px;"
                [disabled]="isCreatingTicket">Next</button>
        </mat-dialog-actions>

        <mat-dialog-actions *ngIf="stepper.selectedIndex == 2">
            <button mat-flat-button (click)="stepper.previous()" [disabled]="isCreatingTicket">Back</button>
            <button mat-raised-button color="primary" (click)="onSubmit()" style="max-width: 200px;"
                [disabled]="isCreatingTicket">Save</button>
        </mat-dialog-actions>


    </form>



</div>